import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Constants, Globals } from 'utils';
import { AccreditationService } from 'services';
import { CheckWhiteIcon } from 'assets/icons';

interface Props {
	onClose?: any;
}

class ModalConfig extends React.Component<Props> {

	state = {
		form: {
			auto_accreditations: Constants.AUTOACCREDITATIONS.NO,
			payment_method_id: Constants.PAYMENT_METHODS.BNC
		}
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await AccreditationService.admin.getConfig();
		this.setState({
			form: {
				...this.state.form,
				auto_accreditations: res.config?.auto_accreditations || Constants.AUTOACCREDITATIONS.NO,
				payment_method_id: res.config?.payment_method_id || Constants.PAYMENT_METHODS.BNC
			}
		});
	}

	submit = async () => {
		await AccreditationService.admin.saveConfig({
			...this.state.form
		});
		this.props.onClose();
		Globals.showSuccess("Se ha guardado la configuración correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-view-config">
				<div className="check-container" onClick={ () => {
					this.setState({
						form: {
							...this.state.form,
							auto_accreditations: !this.state.form.auto_accreditations
						}
					});
				} }>
					<div className={ `check ${ this.state.form.auto_accreditations == Constants.AUTOACCREDITATIONS.YES ? 'active' : '' }` }>
						{
							this.state.form.auto_accreditations == Constants.AUTOACCREDITATIONS.YES && (
								<img src={ CheckWhiteIcon } />
							)
						}
					</div>
					<p>Autoacreditaciones</p>
				</div>
				{/*<Select
					color="white"
					placeholder="Seleccionar"
					label="Método de cobro"
					name="payment_method_id"
					onChange={ (e: any) => this.change(e) }
					value={ this.state.form.payment_method_id }
					options={ [
						{ value: Constants.PAYMENT_METHODS.BNC.toString(), label: 'BNC' },
						{ value: Constants.PAYMENT_METHODS.R4.toString(), label: 'R4' },
					] } />*/}
				<div className="text-center">
					<Button type="submit" className="btn-save" onClick={ () => this.submit() }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalConfig;